import { render, staticRenderFns } from "./ButtonFb.vue?vue&type=template&id=2d3bd2c2&scoped=true&lang=pug&"
import script from "./ButtonFb.vue?vue&type=script&lang=js&"
export * from "./ButtonFb.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFb.vue?vue&type=style&index=0&id=2d3bd2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bd2c2",
  null
  
)

export default component.exports